import { render, staticRenderFns } from "./IssueList.vue?vue&type=template&id=4cf5d6c3&scoped=true&"
import script from "./IssueList.vue?vue&type=script&lang=js&"
export * from "./IssueList.vue?vue&type=script&lang=js&"
import style0 from "./IssueList.vue?vue&type=style&index=0&id=4cf5d6c3&lang=scss&scoped=true&"
import style1 from "./IssueList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf5d6c3",
  null
  
)

export default component.exports